<div class="about-us">
  <h2>درباره ایپـــام</h2>
  <p>
    شرکت دانش‌بنیان ایده‌ پرداز دانش نوین آرشام (ایپام) در سال 1396 تاسیس و با اخذ مجوزهای پرداخت‌یاری و پرداخت‌سازی از بانک مرکزی جمهوری اسلامی و
    شاپرک، به ارائه خدمات و راه‌کارهای بی‌همتا در حوزه‌های مالی همچون بانکداری مجازی، بانکداری باز، اینشورتک و سوپرمارکت مالی می‌پردازد. این شرکت
    می‌کوشد تا با استفاده از فناوری‌های نوین و مبتکرانه، متخصصین توانمند این حوزه و زیرساخت‌های فنی منحصربه‌فرد، صنعت بزرگ فین‌تک را در ایران هم‌سطح
    با پیشرفت‌های جهانی ارتقا دهد.
  </p>

  <p>
    ایپام یکی از شرکت‌های زیرمجموعه <span (click)="clickSite('https://tenian.ir/')">هلدینگ توسعه تجارت الکترونیک تنیان</span> و
    <span (click)="clickSite('https://tourismbank.ir/')"> بانک گردشگری</span> است. در حال حاضر ایپام عملاً به عنوان بازوی فنی بانک گردشگری، با همکاری
    این بانک و کمک به توسعه‌ی زیرساخت‌های مالی در روال کاریِ مشتریان، به دنبال طرح راهکارها و راه‌حل‌های نوین و تسهیل انواع فرآیندهای مالی آنان است.
    این فرآیند به نوبه‌ی خود سبب اطمینان خاطر و جلب رضایت مشتریان می‌شود.
  </p>
  <h3>چشم‌انداز</h3>
  <p>
    از اهداف و چشم‌اندازهای مرکز نوآوری مالی ایپام، تبدیل این شرکت به جامع‌ترین و کامل‌ترین برند تسهیل کننده و ارائه‌دهنده خدمات پرداخت در سطح کشور و
    تبدیل به بزرگ‌ترین مرکز نوآوری تخصصی کشور در حوزه صنعت بزرگ فین‌تک کشور می‌باشد. این اهداف با بکارگیری نیروهای متخصص و جوان، ورود و استفاده از
    برترین ایده‌های نوآوری در حوزه مالی کشور و تلاش برای ارتقاء سطح کیفی حوزه‌های مذکور کاملا در دسترس است.
  </p>
  <h3>ارزش‌ها</h3>
  <div style="display: flex; padding: 10px 0;">
    <h4>اعتماد:</h4>
    &nbsp;
    <span> تعهدات را مسئولانه انجام داده و همیشه به قول خود عمل می‌کنیم .</span>
  </div>
  <div style="display: flex; padding: 10px 0;">
    <h4>نوآوری:</h4>
    &nbsp;
    <span> ما فن‌آوری نوین را توسعه و به‌کار می‌گیریم. شنوا، آموزنده و در جستجوی بهترین ایده‌ها هستیم.</span>
  </div>
  <div style="display: flex; padding: 10px 0;">
    <h4>امنیت:</h4>
    &nbsp;
    <span> اولویت ما حفظ امنیت همه جانبه پروژه‌های در حال انجام است.</span>
  </div>
  <div style="display: flex; padding: 10px 0;">
    <h4>حفظ منافع ذی‌نفعان:</h4>
    &nbsp;
    <span>کار خود را یک‌بار و کامل انجام می‌دهیم، ارزش ما به دیدگاه کارفرما و جامعه بستگی دارد. </span>
  </div>
  <div style="display: flex; padding: 10px 0;">
    <h4>پایداری:</h4>
    &nbsp;
    <span> ثبات، نظم، تعهد و پشتیبانی صحیح از عوامل پایداری ما است.</span>
  </div>
  <div class="banner">
    <img src="assets/about-us.png" />
  </div>
</div>
